import styled from "styled-components";
import { theme } from "../theme/toyotaTheme";

export const Tags = styled.div``;

export const Tag = styled.div.attrs(() => ({
    className: "t-milli-text",
}))`
    display: inline-block;
    padding: 3px 11px;
    color: ${theme.colors.grey7};
    &:first-child {
        padding-left: 0;
    }
    &:last-child {
        padding-right: 0;
    }

    html[dir="rtl"] & {
        &:first-child {
            padding-right: 0;
        }
        &:last-child {
            padding-left: 0;
        }
    }
`;
